// BuzzBump - Site content (navigation, features, project, team values, support tiers, FAQ)

export const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'Notre Projet', path: '/notre-projet' },
  { label: 'À propos de nous', path: '/a-propos' },
  { label: 'Nous contacter', path: '/contact' },
  { label: 'Nous aider', path: '/nous-aider' },
  { label: 'Inscription', path: '/inscription' },
];

// Images officielles de buzzbump.fr
export const heroImages = {
  hero: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=1920&q=80',
  sectionBg: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=1920&q=80',
  bottomBg: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=1920&q=80',
  // Notre Projet sections - unique images
  projetObjectif: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80',
  projetMessagerie: 'https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?auto=format&fit=crop&w=1200&q=80',
  projetSocial: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80',
  // À propos sections
  aproposHero: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1600&q=80',
  aproposStory: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80',
};

export const homeFeatures = [
  {
    id: 'defis',
    title: 'Défis et Classement',
    description: "BuzzBump vous propose des défis à relever dans la vie réelle avec vos amis ou d'autres joueurs tout en suivant vos scores et ceux de la communauté sur un classement interactif.",
    image: 'https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?auto=format&fit=crop&w=1200&q=80',
    link: '/notre-projet',
    icon: 'Trophy',
  },
  {
    id: 'reel',
    title: 'Défis dans la Vie Réelle',
    description: "Participez à des challenges authentiques qui se déroulent autour de vous pour vivre une expérience fun et immersive.",
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=80',
    link: '/notre-projet',
    icon: 'Zap',
  },
  {
    id: 'messagerie',
    title: 'Messagerie Instantanée Innovante',
    description: "Communiquez facilement avec vos amis grâce à un système inspiré des meilleurs réseaux sociaux.",
    image: 'https://images.unsplash.com/photo-1592890288564-76628a30a657?auto=format&fit=crop&w=1200&q=80',
    link: '/notre-projet',
    icon: 'MessageCircle',
  },
  {
    id: 'map',
    title: 'Map Dynamique',
    description: "Visualisez en temps réel la position des autres joueurs pour les défier dans un duel, le premier à réaliser sa crasse à l'autre gagne et monte dans le classement !",
    image: 'https://images.unsplash.com/photo-1604357209793-fca5dca89f97?auto=format&fit=crop&w=1200&q=80',
    link: '/notre-projet',
    icon: 'MapPin',
  },
  {
    id: 'communaute',
    title: 'Communauté Active et Engagée',
    description: "Rejoignez une communauté motivée, prête à relever tous les défis et à partager ses exploits.",
    image: 'https://images.unsplash.com/photo-1511988617509-a57c8a288659?auto=format&fit=crop&w=1200&q=80',
    link: '/notre-projet',
    icon: 'Users',
  },
];

export const projectSections = {
  objectif: {
    title: 'Notre objectif !',
    intro: "Notre souhait le plus cher est de proposer une expérience immersive et sans limite en proposant à nos joueurs la possibilité de défier leurs ami(e)s chacun à sa manière. Mais ce n'est pas tout !",
    bullets: [
      "En plus de pouvoir défier ses amis, nos joueurs ont la possibilité de se défier entre eux même sans se connaître !",
      "Grâce à notre système de Map, vous pourrez voir en temps réel le profil des autres joueurs et où ils se trouvent. Vous pourrez ensuite les défier et choisir vous-même la crasse que vous souhaitez leur faire, il fera de même en retour !",
      "Celui qui réussit à réaliser sa crasse avant l'autre l'emporte et amasse tous les points ! Mais gare à vous s'il demande une revanche...",
    ],
  },
  classement: {
    title: 'Classement',
    bullets: [
      "Plus la crasse que vous choisissez est cruelle, plus vous remportez de points si vous la réalisez... Sans vous faire démasquer avant bien sûr !",
      "Plus vous aurez de points, plus vous grimperez dans le classement. Seuls les joueurs les plus sadiques et vicieux termineront en haut du classement !",
      "Plus vous monterez dans le classement, plus vous obtiendrez de récompenses !",
    ],
  },
  modes: {
    title: 'Mode de Jeu',
    subtitle: 'Notre jeu bénéficiera de deux modes de jeu.',
    modes: [
      {
        name: 'Mode -18 ans',
        description: "Un mode dédié aux joueurs de moins de 18 ans qui sera plus restreint, principalement sur les crasses : elles seront aléatoires mais prédéfinies par les soins de notre équipe pour éviter tout abus et pour que l'expérience de jeu reste la plus amusante possible. Dans ce mode, les joueurs ne jouent qu'entre moins de 18 ans, les profils des joueurs majeurs ne s'afficheront pas sur la map.",
      },
      {
        name: 'Mode +18 ans',
        description: "Le deuxième mode sera exclusivement dédié aux joueurs de plus de 18 ans. La particularité de ce mode est que ce sont les joueurs qui vont créer leurs propres crasses à faire à leurs ami(e)s ou aux joueurs à proximité qu'ils défieront. Bien évidemment, ils ne pourront pas voir les joueurs de moins de 18 ans sur la map et donc impossible de les défier.",
      },
    ],
  },
  messagerie: {
    title: 'Messagerie Intégrée',
    text: "Notre messagerie intégrée qui sera inspirée des meilleures messageries actuellement disponibles. L'objectif sera d'améliorer les échanges entre inconnus permettant de faire de nouvelles rencontres et de s'amuser ensemble !\n\nPour provoquer ses amis ou de potentiels adversaires afin de les prévenir que vous comptez leur faire une crasse car vous êtes de vrais sadiques, rien de mieux !",
    subtitle: "Quelle est la différence si je joue avec des amis ou des inconnus ?",
    friends: "Avec vos amis, une fois que vous avez écrit la crasse que vous comptez faire et choisi à qui, tous les amis dans votre partie recevront une notification leur indiquant que quelqu'un s'apprête à faire une crasse, mais personne ne saura qui doit la faire et à qui il doit la faire ! Vous pouvez accuser un ami que vous soupçonnez de vouloir vous crasser avant qu'il ne le fasse. Si vous avez vu juste, vous remportez les points, mais si vous vous êtes trompé, vous en perdez davantage.",
    strangers: "Avec des inconnus il vous suffira d'accéder à la Map, de sélectionner un joueur à proximité de vous, puis choisir la crasse que vous souhaitez lui infliger. Une fois cela fait, votre adversaire recevra une notification et aura la possibilité de choisir une crasse à vous faire... Le premier qui réussit à faire sa crasse à l'autre ressortira vainqueur et amassera tous les points !",
  },
  social: {
    title: 'Réseau Social et Caméra',
    text: "Nous vous invitons aussi à profiter de l'expérience incroyable de notre réseau social interne en filmant les crasses que vous faites à vos amis grâce à l'icône caméra qui vous permettra de filmer les moments où vous piégerez vos amis. Vous pourrez ensuite les poster sur le réseau social interne.\n\nBien sûr, vous pourrez également profiter du réseau social en regardant tout simplement les crasses que des inconnus auront faites à leurs amis !",
  },
};

export const stats = [
  { value: '∞', label: 'Défis disponibles', icon: 'Trophy' },
  { value: '24/7', label: 'Messagerie en temps réel', icon: 'MessageCircle' },
  { value: '∞', label: 'Possibilités de fun', icon: 'Sparkles' },
];

export const faq = [
  {
    q: "Qu'est-ce que BuzzBump ?",
    a: "BuzzBump est une application mobile innovante qui combine défis urbains interactifs, messagerie dynamique et carte des scores pour des expériences sociales et ludiques uniques.",
  },
  {
    q: "Comment fonctionne le classement ?",
    a: "Plus la crasse que vous réalisez est audacieuse, plus vous gagnez de points. Les meilleurs joueurs grimpent au sommet et débloquent des récompenses exclusives.",
  },
  {
    q: "L'application est-elle gratuite ?",
    a: "Oui, BuzzBump sera disponible gratuitement au lancement avec des fonctionnalités premium optionnelles.",
  },
  {
    q: "Comment puis-je aider le projet ?",
    a: "Vous pouvez nous soutenir en partageant notre projet, en participant à la bêta ou en faisant un don sur la page 'Nous aider'.",
  },
];

export const helpTiers = [
  {
    name: 'Soutien Abeille',
    price: '5€',
    lookup_key: 'tier_abeille_5eur',
    perks: ['Mention dans nos remerciements', 'Newsletter exclusive avec les coulisses'],
    popular: false,
  },
  {
    name: 'Soutien Ruche',
    price: '25€',
    lookup_key: 'tier_ruche_25eur',
    perks: ['Tous les avantages Abeille', 'Accès anticipé à la bêta de l\'app', 'Badge collector dans l\'app'],
    popular: true,
  },
  {
    name: 'Soutien Reine',
    price: '100€',
    lookup_key: 'tier_reine_100eur',
    perks: ['Tous les avantages Ruche', 'Nom dans les crédits de l\'app', 'Skin de profil exclusif in-game'],
    popular: false,
  },
];

export const teamValues = [
  { title: 'Innovation', desc: 'Repousser les limites du divertissement mobile.', icon: 'Lightbulb' },
  { title: 'Communauté', desc: 'Créer du lien entre joueurs de tous horizons.', icon: 'Heart' },
  { title: 'Fun', desc: "L'amusement avant tout, sans compromis.", icon: 'Smile' },
  { title: 'Sécurité', desc: "Un environnement de jeu sûr et bienveillant.", icon: 'Shield' },
];
